/**
 * Note: State initialization happens before the config is loaded, so we can't use config values.
 */
import { constants } from '../../../componentsConstants'

export const playerStoreKey = 'playerStore'

export const playerStoreKeys = {
  Reality: 'Reality',
  accessToken: 'accessToken',
  accountSessionId: 'accountSessionId',
  accountSessionKicked: 'accountSessionKicked',
  activeCurrencyId: 'activeCurrencyId',
  activeTabId: 'activeTabId',
  allowAutomaticLogin: 'allowAutomaticLogin',
  country: 'country',
  currency: 'currency',
  diamondsExcluded: 'diamondsExcluded',
  emailAddress: 'emailAddress',
  emailVerified: 'emailVerified',
  favoriteGames: 'favoriteGames',
  firebaseToken: 'firebaseToken',
  firstName: 'firstName',
  geoblockLobbyInteraction: 'geoblockLobbyInteraction',
  geoForceReCheck: 'geoForceReCheck',
  triggerGeoPermissionNeededModal: 'triggerGeoPermissionNeededModal',
  geolocationStatus: 'geolocationStatus',
  hasBonusOffer: 'hasBonusOffer',
  iovation: 'iovation',
  kycStatus: 'kycStatus',
  lastGameLoaded: 'lastGameLoaded',
  lastLogin: 'lastLogin',
  lastName: 'lastName',
  limitNotice: 'limitNotice',
  limitTriggered: 'limitTriggered',
  loginUser: 'loginUser',
  notices: 'notices',
  phoneNumber: 'phoneNumber',
  playerActiveCurrencyData: 'playerActiveCurrencyData',
  playerAgreeTerms: 'playerAgreeTerms',
  playerConfirmPrivacy: 'playerConfirmPrivacy',
  playerFreezeInfo: 'playerFreezeInfo',
  playerLoyaltyData: 'playerLoyaltyData',
  playerProductsStore: 'playerProductsStore',
  playerPromoCode: 'playerPromoCode',
  playerSessionData: 'playerSessionData',
  playerSignupEmail: 'playerSignupEmail',
  playerSmsInfo: 'playerSmsInfo',
  playerTcAccepted: 'playerTcAccepted',
  playerUserName: 'playerUserName',
  playerWallets: 'playerWallets',
  preferredLobby: 'preferredLobby',
  previousGames: 'previousGames',
  promos: 'promos',
  purchaseLimitKycStatus: 'purchaseLimitKycStatus',
  refId: 'refId',
  refreshCount: 'refreshCount',
  refreshToken: 'refreshToken',
  socialBankroll: 'socialBankroll',
  socialData: 'socialData',
  socialReferral: 'socialReferral',
  socialTimeToLive: 'socialTimeToLive',
  smsVerified: 'smsVerified',
  status: 'status',
  subdivision: 'subdivision',
  tagsBanner: 'tagsBanner',
  tagsGames: 'tagsGames',
  tagsInbox: 'tagsInbox',
  tagsPlayer: 'tagsPlayer',
  taxInfoStatus: 'taxInfoStatus',
  timeToLive: 'timeToLive',
  timestamp: 'timestamp',
  userId: 'userId',
  username: 'username',
  validateMethod: 'validateMethod',
  accessTokenExpirationDateMs: 'accessTokenExpirationDateMs'
}

export const playerProductsStoreKeys = {
  productsStoreData: 'productsStoreData',
  products: 'products',
  assetUrl: 'assetUrl',
  blocked: 'blocked',
  missingBannerProducts: 'missingBannerProducts'
}

/**
 * update localStorageVersion in storeConstants.js every time a new property is added or removed from the zustand store;
 * for more see SWEEP-8185
 */
export const playerStoreInitialValues = {
  [playerStoreKeys.playerActiveCurrencyData]: {
    currencyId: '',
    currencyName: ''
  },
  [playerStoreKeys.playerSmsInfo]: {
    smsVerified: false,
    lockedSmsVerified: false,
    smsVerifiedFunc: null,
    smsInfoChecked: false
  },
  [playerStoreKeys.notices]: [],
  [playerStoreKeys.playerWallets]: {},
  [playerStoreKeys.activeCurrencyId]: constants.wallets.swcWalletId,
  [playerStoreKeys.previousGames]: null,
  [playerStoreKeys.lastGameLoaded]: null,
  [playerStoreKeys.playerProductsStore]: {
    [playerProductsStoreKeys.productsStoreData]: {
      [playerProductsStoreKeys.products]: [], // product jsons in the store
      [playerProductsStoreKeys.blocked]: false,
      [playerProductsStoreKeys.assetUrl]: ''
    },
    [playerProductsStoreKeys.missingBannerProducts]: [] // uuids of the banner purchase products that are not found in the store
  },
  [playerStoreKeys.timestamp]: null,
  [playerStoreKeys.socialData]: {},
  [playerStoreKeys.socialBankroll]: 0,
  [playerStoreKeys.favoriteGames]: {},
  [playerStoreKeys.playerLoyaltyData]: {
    currentTier: {},
    progress: null
  },
  [playerStoreKeys.playerSessionData]: {},
  [playerStoreKeys.limitTriggered]: '',
  [playerStoreKeys.limitNotice]: {},
  [playerStoreKeys.accessToken]: {
    encryptedToken: ''
  },
  [playerStoreKeys.refreshToken]: {
    encryptedToken: ''
  },
  [playerStoreKeys.refreshCount]: 0,
  [playerStoreKeys.firebaseToken]: null,
  [playerStoreKeys.playerFreezeInfo]: {},
  [playerStoreKeys.playerTcAccepted]: false,
  [playerStoreKeys.username]: '',
  [playerStoreKeys.kycStatus]: null,
  [playerStoreKeys.taxInfoStatus]: null,
  [playerStoreKeys.country]: '',
  [playerStoreKeys.preferredLobby]: '',
  [playerStoreKeys.activeTabId]: '',
  [playerStoreKeys.allowAutomaticLogin]: true,
  [playerStoreKeys.tagsBanner]: '[]',
  [playerStoreKeys.tagsInbox]: '[]',
  [playerStoreKeys.tagsGames]: '[]',
  [playerStoreKeys.tagsPlayer]: '[]',
  [playerStoreKeys.loginUser]: {
    preferredLanguageCode: ''
  },
  [playerStoreKeys.promos]: '',
  [playerStoreKeys.status]: 'anonymous',
  [playerStoreKeys.validateMethod]: 'email',
  [playerStoreKeys.purchaseLimitKycStatus]: '',
  [playerStoreKeys.userId]: '',
  [playerStoreKeys.currency]: '',
  [playerStoreKeys.playerUserName]: '',
  [playerStoreKeys.lastName]: '',
  [playerStoreKeys.firstName]: '',
  [playerStoreKeys.emailAddress]: '',
  [playerStoreKeys.playerPromoCode]: '',
  [playerStoreKeys.phoneNumber]: '',
  [playerStoreKeys.refId]: '',
  [playerStoreKeys.subdivision]: '',
  [playerStoreKeys.socialTimeToLive]: 0,
  [playerStoreKeys.hasBonusOffer]: false,
  [playerStoreKeys.diamondsExcluded]: false,
  [playerStoreKeys.emailVerified]: false,
  [playerStoreKeys.smsVerified]: false,
  [playerStoreKeys.playerConfirmPrivacy]: false,
  [playerStoreKeys.playerAgreeTerms]: false,
  [playerStoreKeys.playerSignupEmail]: false,
  [playerStoreKeys.accountSessionId]: null,
  [playerStoreKeys.timeToLive]: null,
  [playerStoreKeys.Reality]: null,
  [playerStoreKeys.lastLogin]: null,
  [playerStoreKeys.accountSessionKicked]: null,
  [playerStoreKeys.socialReferral]: null,
  [playerStoreKeys.iovation]: null,
  [playerStoreKeys.geolocationStatus]: {
    geolocationCheckComplete: false,
    xpointCheckInProgress: false,
    geolocationClassicBrandBlockedStatus: true,
    geolocationSweepsBrandBlockedStatus: true,
    geolocationClassicErrors: [],
    geolocationSweepsErrors: []
  },
  [playerStoreKeys.triggerGeoPermissionNeededModal]: false,
  [playerStoreKeys.geoblockLobbyInteraction]: true,
  [playerStoreKeys.geoForceReCheck]: false,
  [playerStoreKeys.accessTokenExpirationDateMs]: 0
}
